export const getVitePublicEnv = (key: string): string => {
    const globalWindow = window as unknown as Record<string, string | undefined>;
    const fromWindow = globalWindow[key];
    if (fromWindow !== undefined) {
        return fromWindow;
    }
    const fromImportMeta = import.meta.env[key];
    return typeof fromImportMeta === 'string' ? fromImportMeta : '';
};
